import { EContractStatus } from '@if/core/types'
import { ButtonProps } from '@mui/material'
import AsyncActionButton from '@src/components/AsyncActionButton'
import { useCreditApplicationById } from '@src/data/api/credit-api/credit-api'
import { useSendSignatureLink } from '@src/data/api/worksheet-api/worksheet-api'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Props extends ButtonProps {
  creditApp: CreditApplication
}

const SignDigitallyButton = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const [shouldPoll, setShouldPoll] = useState(creditApp.contract.status === EContractStatus.Sending)
  const [sendSignatureLink, isSendingSignatureLink, isSendingSignatureLinkError, isSendingSignatureLinkSuccess] =
    useSendSignatureLink(creditApp.financingProgramId, creditApp.id)
  const [fullCreditApplication, isFetching] = useCreditApplicationById(
    { creditApplicationId: creditApp.id, financingProgramId: creditApp.financingProgramId },
    shouldPoll,
  )
  const contract = fullCreditApplication?.contract

  useEffect(() => {
    setShouldPoll(contract.status === EContractStatus.Sending)
  }, [contract])

  const handleClick = async () => {
    await sendSignatureLink(creditApp.id)
  }

  const signDigitallyText = creditApp.hasOngoingElectronicSignature
    ? t('worksheet.signDigitallyLinkSent')
    : t('worksheet.signDigitally')
  return (
    <AsyncActionButton
      fullWidth
      variant="contained"
      isPending={isSendingSignatureLink || shouldPoll}
      isError={isSendingSignatureLinkError}
      isSuccess={isSendingSignatureLinkSuccess}
      onClick={handleClick}
      disabled={isFetching || shouldPoll}
    >
      {isSendingSignatureLink || shouldPoll ? t('common.sending') : signDigitallyText}
    </AsyncActionButton>
  )
}

export default SignDigitallyButton
